// ============================================
// КОМПОНЕНТ АККОРДЕОНА (главная landing, детсад, primary — не middle-high secondary shell)
// ============================================

import { initLandingPageAccordions } from "./unifiedAccordion.js";

function initAccordion() {
  if (document.body.classList.contains("middle-high-page")) return;
  initLandingPageAccordions();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAccordion);
} else {
  initAccordion();
}
